// extracted by mini-css-extract-plugin
export default {"searchBtn":"SearchForm_searchBtn__vqQSZ"};